/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vc_Faq_TitleInputs */

const en_vc_faq_title = /** @type {(inputs: Vc_Faq_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`VectorCraft FAQ`)
};

const zh_vc_faq_title = /** @type {(inputs: Vc_Faq_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`VectorCraft 常见问题`)
};

/**
* | output |
* | --- |
* | "VectorCraft FAQ" |
*
* @param {Vc_Faq_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const vc_faq_title = /** @type {((inputs?: Vc_Faq_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vc_Faq_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_vc_faq_title(inputs)
	return zh_vc_faq_title(inputs)
});
export { vc_faq_title as "vc.faq.title" }